import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection } from '../ruutsApi/normalize'

export const getFrontPaddocks = paddocks =>
  paddocks.map(paddock => ({
    ...paddock,
    geometry: paddock.uncroppedGeometry,
    toGeoJSON: paddock.toUncroppedGeoJSON,
  }))

export const getPaddocks = async ({ farmId, signal }) => {
  const response = await apiClient.get(endpoints.paddocks, { params: { farmId }, signal })
  return getFrontPaddocks(unwrapCollection(response))
}
